import { render } from "./PoliticadeprivacidadView.vue?vue&type=template&id=696e53f8&scoped=true"
const script = {}

import "./PoliticadeprivacidadView.vue?vue&type=style&index=0&id=696e53f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696e53f8"]])

export default __exports__